module.exports = __webpack_public_path__ + "img/old_ls_shop_icon.eeeb728c.svg";